module.exports = __webpack_public_path__ + "static/lightning-card-illustration-688919f7aa11bdc0f1e4e3ddc32a50c4.png";